<template>
    <table class="table table-striped">
        <thead v-if="$slots.thead">
            <tr><slot name="thead"/></tr>
        </thead>
        <tbody>
            <slot />
        </tbody>
    </table>
</template>
